import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'freedom_association_collective_bargaining'

export const dataPointDefinition = {
  retracedId: 'freedom_association_collective_bargaining',
  name: 'Freedom of association and collective bargaining',
  description:
    'The intent of this option selection is to understand if the facility has written policies and/or procedures in place on the topic of "Freedom of association and collective bargaining". ',
  meta: {
    slcpMeta: {
      key: 'ms-1--2-11x',
      number: 'MS-PLA-4-11',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1--2-11x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32180,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
